<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Extension for Google Chrome') }}</h4>
        </div>
        <div class="btn-row">
          <div class="form-inline">
            <a
              href="https://chrome.google.com/webstore/detail/quickin-addon-utility/kemdbebadbdnbppmhdahnfhkdhchppff?hl=pt-BR"
              type="button"
              class="btn btn-secondary mr-2"
              target="_blank">
              Google Chrome Extension
              </a>
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1 p-3">

      <div style="max-width: 800px;">

        <div
          class="alert alert-danger"
          v-if="!permissions.includes('manage_candidates')">
          Você não poderá usar essa extensão pois você não possui permissão para incluir candidatos.
        </div>
        
        <p>Nossa extensão do Chrome permite importar candidatos automaticamente do LinkedIn, Catho e Infojobs e facilita a cópia dos dados de qualquer outro site ou banco de candidatos na Internet.</p>

        <div class="mb-3">
          <h4><span class="text-primary">1.</span> {{ $t('Installing the extension in Chrome') }}</h4>

          <ul class="list-group my-4">
            <li class="list-group-item">
              {{ $t('Install it in Chrome using the link below:') }}
              <div class="mt-2">
                <a
                  href="https://chrome.google.com/webstore/detail/quickin-addon-utility/kemdbebadbdnbppmhdahnfhkdhchppff?hl=pt-BR"
                  type="button"
                  class="btn btn-primary"
                  target="_blank">
                  Google Chrome Extension
                  </a>
              </div>
            </li>
            <li class="list-group-item">
              {{ $t('Click on "Use no Chrome"') }}
            </li>
            <li class="list-group-item">
              {{ $t('Click on "Add extension" of the alert.') }}
              <div class="mt-2">
                <img src="../../assets/img/browser-extension/permission-extension.jpg" style="max-width: 100%;">
              </div>
            </li>
          </ul>
        </div>

        <div class="mb-3">
          <h4><span class="text-primary">2.</span> {{ $t('Importing or profile') }}</h4>

          <ul class="list-group my-4">
            <li class="list-group-item">
              {{ $t('Go to the page of a candidate on the site that you want to import.') }}<br>
              Por exemplo: <a href="https://www.linkedin.com/in/jeffweiner08/" target="_blank">https://www.linkedin.com/in/jeffweiner08/</a>
            </li>
            <li class="list-group-item">
              Clique no ícone do Quickin na barra do navegador. Isso abrirá a extensão de importação.<br>
              NOTA: Se você ainda não está conectado, basta fazer o login com seu usuário e senha no site do Quickin.
              <div class="mt-2">
                <img src="../../assets/img/browser-extension/import-start.jpg" style="max-width: 100%;">
              </div>
            </li>
            <li class="list-group-item">
              Verifique os detalhes do candidato e preencha os campos vazios.
            </li>
            <li class="list-group-item">
              Você poderá adicionar o candidato em uma vaga, basta seleciona-la no início do formulário.
              <div class="mt-2">
                <img src="../../assets/img/browser-extension/select-job.jpg" style="max-width: 100%;">
              </div>
            </li>
            <li class="list-group-item">
              Ao selecionar um vaga, o campo de Nota será exibido: adicione aqui qualquer comentário que você tiver sobre o candidato. Seu comentário aparecerá na seção de notas no perfil do candidato no Quickin.
              <div class="mt-2">
                <img src="../../assets/img/browser-extension/add-note.jpg" style="max-width: 100%;">
              </div>
            </li>
            <li class="list-group-item">
              Você pode baixar e arrastar um documento para o campo Currículo.
            </li>
            <li class="list-group-item">
              Quando você estiver pronto para importar o candidato, clique no botão <strong>“Salvar”</strong> no final.
            </li>
          </ul>
        </div>

        <div class="mb-3">
          <h4><span class="text-primary">3.</span> Acessando o candidato</h4>
          <ul class="list-group my-4">
            <li class="list-group-item">
              Após salvar o candidato, você poderá acessar diretamente o perfil importado na ferramenta.
              <div class="mt-2">
                <img src="../../assets/img/browser-extension/access-profile.jpg" style="max-width: 100%;">
              </div>
            </li>
          </ul>
        </div>

      </div>

    </div>

  </div>

</template>

<script>
export default {
  name: 'BrowserExtension',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul.list-group {
}
  ul.list-group li {
    padding: 1.3em;
  }
</style>



// WEBPACK FOOTER //
// src/components/BrowserExtension/BrowserExtension.vue